import React, { useEffect, useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";

const ImageWithShimmer = ({ src, alt }) => {
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    setIsLoading(false);
  }, []);

  return (
    <div className="image-wrapper">
      {isLoading ? (
        <div
          style={{ display: "block", width: "100%" }}
          className="inline-flex min-w-[300px] min-h-[400px]  w-fit text-white  animate-shimmer items-center justify-center rounded-md  mx-auto   bg-[linear-gradient(110deg,#dddddd,45%,#39A78E,55%,#dddddd)] bg-[length:200%_100%] px-12 p-4 font-semibold  "
        />
      ) : (
        <LazyLoadImage
          src={src}
          alt={alt}
          className="max-w-[400px]"
          style={{ display: "block", width: "100%" }}
        />
      )}
    </div>
  );
};

export default ImageWithShimmer;
